import { MagicSet } from "@apiserver-rest/ponder-data-client-base";

export class MagicSetTree {
    /**
     * Given a list of sets, creates a flattened array of their tree-based hierarchy.
     * @param sets 
     */
    public flatten(sets: MagicSet[]): MagicSetNode[] {
        // First, create the root node and all of the child nodes.
        var root = { set: undefined, depth: -1, parent: undefined, children: [], depthClass: "" };
        var nodeMap = new Map<string, MagicSetNode>();

        sets.forEach(s => {
            if (s.cardCount) {
                nodeMap.set(s.id, { set: s, depth: -1, parent: undefined, children: [], depthClass: "" });
            }
        });

        // Next, connect each node to its parent.
        sets.forEach(s => {
            if (s.cardCount) {
                var node = nodeMap.get(s.id)!;
                
                // If this set has a parent, then find it and attach it.
                if (s.parentId) {
                    var parent = nodeMap.get(s.parentId);
    
                    if (parent) {
                        node.parent = parent;
                    }
                }
    
                // If set had no parent (or we failed to find it) then attach to root.
                if (!node.parent) {
                    node.parent = root;
                }
    
                node.parent.children.push(node);
            }
        });

        // Finally, do a depth-first traversal of the node tree to assign depth values.
        var arr: MagicSetNode[] = [];
        this.traverse(root, -1, arr);

        return arr;
    }

    /**
     * Performs a depth-first traversal of the node tree.
     * Updates the depth of each node and also adds it into the flattened array representation.
     * @param node 
     * @param depth 
     * @param arr 
     */
    private traverse(node: MagicSetNode, depth: number, arr: MagicSetNode[]) {
        node.depth = depth;
        node.depthClass = `${(depth * 16)}px`;

        node.children.forEach(c => {
            arr.push(c);                            // Wait until now to add to the array so we do not add the root.
            this.traverse(c, depth + 1, arr);
        });
    }
    
}

export type MagicSetNode = {
    set?: MagicSet;
    depth: number;
    parent?: MagicSetNode;
    children: MagicSetNode[];
    depthClass: string;
};